import classNames from 'classnames';

import { PF } from '@pages/Clients/NewClientsList/data/constants';
import type { FilterType } from '@pages/Clients/NewClientsList/types';

import type { FC } from 'react';

export const FilterTypeComponent: FC<{ type: FilterType; hide: boolean }> = ({
  type,
  hide = false,
}) => {
  return (
    <div
      className={classNames(`${PF}__type`, {
        [`${PF}__type--hide`]: hide,
      })}
    >
      {!hide && (type === 'and' ? 'И' : 'ИЛИ')}
    </div>
  );
};
